import * as React from 'react';
import { Container, Image, Text } from './style/noDataStyle';
import { translateToString } from '../../styles/global/translate';
import NoDataImage from 'images/icons/noData/no_data.svg';
import NoDataImageError from 'images/icons/noData/no_data_error.svg';
import NoResultImage from 'images/icons/noData/no_result.svg';
import { FlexDiv } from '../products/style';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { ButtonStyle } from '../../components_v2/popup/PopupCreation';

type Props = {
	messageButton?: React.ReactNode
	urlButton?: string
	height?: string
	backgroundColor?: string
	borderRadius?: string
	isError?: boolean
	isNoResult?: boolean
	onClickButton?: () => void
	messageButton2?: React.ReactNode
	onClickButton2?: () => void
}

export function Unhautorized(props: Props) {
	return <NoData {...props} message={translateToString('you_are_not_autorized')} />;
}

export default function NoData(props: Props & { message: React.ReactNode }) {
	return (
		<Container height={props.height} backgroundColor={props.backgroundColor} borderRadius={props.borderRadius}>
			<Image
				src={props.isError ? NoDataImageError : props.isNoResult ? NoResultImage : NoDataImage}
				alt='no_data_image'
			/>
			<FlexDiv flow="column" align="stretch" gap='16px'>
				<Text>
					{props.message}
				</Text>
				<FlexDiv justify='center'>
					{
						((props.onClickButton || props.urlButton) && props.messageButton) &&
						<DefaultButton
							minWidth='130px'
							onClick={_ => {
								if (props.onClickButton) props.onClickButton();
								else window.open(props.urlButton, '_blank');
							}}> {props.messageButton}
						</DefaultButton>
					}
					{
						((props.onClickButton2) && props.messageButton2) &&
						<DefaultButton
							buttonStyle={ButtonStyle.White}
							minWidth='130px'
							onClick={_ => {
								if (props.onClickButton2) props.onClickButton2();
							}}> {props.messageButton2}
						</DefaultButton>
					}
				</FlexDiv>
			</FlexDiv>
		</Container>
	);
}
